export const AUTH_SHELL_PATHS = new Set([
  '/login',
  '/auth/login',
  '/register',
  '/verify-email',
  '/registration-recovery',
  '/forgot-password',
  '/auth/password',
])

export function isAuthShellPath(path: string): boolean {
  return AUTH_SHELL_PATHS.has(path)
    || path.startsWith('/auth/password/reset')
    || path.startsWith('/setup/')
}
